import { render, staticRenderFns } from "./NumerationDocumentLegal.vue?vue&type=template&id=9b4c44c0&"
import script from "./NumerationDocumentLegal.vue?vue&type=script&lang=js&"
export * from "./NumerationDocumentLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports